import React, { useState, useContext } from 'react';
import { useConfig } from './useConfig.esm.js';

const CurrencyContext = React.createContext(void 0);
const CurrencyProvider = ({ children }) => {
  const config = useConfig();
  const currencies = config.currencies;
  const engineers = currencies.find((currency2) => currency2.kind === null);
  const [currency, setCurrency] = useState(
    engineers || currencies[0]
  );
  return /* @__PURE__ */ React.createElement(CurrencyContext.Provider, { value: { currency, setCurrency } }, children);
};
function useCurrency() {
  const context = useContext(CurrencyContext);
  if (!context) {
    assertNever();
  }
  return [context.currency, context.setCurrency];
}
function assertNever() {
  throw Error("Cannot use useCurrency outside of CurrencyProvider");
}

export { CurrencyContext, CurrencyProvider, useCurrency };
//# sourceMappingURL=useCurrency.esm.js.map
